import React from 'react';

export function EyebrowLabel({ children, dark }) {
  return (
    <div className={`inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] ${dark ? 'text-white/60' : 'text-[#7A2E48]'}`}>
      <span className={`w-6 h-px ${dark ? 'bg-white/40' : 'bg-[#C4506F]'}`} />
      {children}
    </div>
  );
}

export function SectionTitle({ children, className = '', as: As = 'h2', dark }) {
  return (
    <As
      className={`font-serif tracking-tight ${dark ? 'text-white' : 'text-[#1A1420]'} ${className}`}
      style={{ fontFamily: "'Fraunces', serif", fontWeight: 400 }}
    >
      {children}
    </As>
  );
}

export function Container({ children, className = '' }) {
  return <div className={`max-w-[1240px] mx-auto px-6 lg:px-10 ${className}`}>{children}</div>;
}
